import React from 'react'
import styles from './MiniFeed.scss'
import { Link } from 'react-router'
import { MiniListItem, MiniListItemDetail } from '../DashboardElements'
import { Card } from 'common/styleguide/Card'
import { IntroWidget } from 'common/IntroWidget'
import { ProfileImg } from 'common/ProfileImg'
import { TextWithBolds } from 'common/TextWithBolds'
import { AccountTypeBadge } from 'common/AccountTypeBadge'
import { Msg, accountLevels } from 'lib/localization'
import smartDate from '@qrohlf/smart-date'
import { FormattedMessage as T, defineMessages } from 'react-intl'

const messages = defineMessages({
  viewFeed: {
    id: 'MiniFeed.viewFeed',
    defaultMessage: 'View Feed'
  }
})

export class MiniFeed extends React.PureComponent {
  render () {
    const { feedItems } = this.props
    if (!feedItems || feedItems.length === 0) {
      return <Intro />
    }
    return (
      <Card>
        {feedItems.map(f => <FeedItem key={f.id} f={f} />)}
        <Link data-card-link to='/feed'>
          <Msg m={messages.viewFeed} />
        </Link>
      </Card>
    )
  }
}

const FeedItem = ({ f }) => {
  const subscriptionFeedItem = f.associatedObjectType === 'Subscription'
  return <MiniListItem href={f.content.url}>
    <div style={{ display: 'flex' }}>
      <div style={{ marginRight: '10px' }}>
        <ProfileImg
          userId={f.content.user_id}
          highlightedPhotoId={f.content.highlighted_photo_id} />
      </div>
      <div>
        {subscriptionFeedItem
          ? <SubscriptionMiniFeedItem userName={f.content.user_name} accountLevel={f.content.account_level} />
          : <TextWithBolds text={f.content.rich_title} />}
        <MiniListItemDetail>
          {smartDate(f.createdAt, { relative: true, includeTime: false })}
        </MiniListItemDetail>
      </div>
    </div>
  </MiniListItem>
}

const Intro = () => (
  <Card>
    <IntroWidget i='md-person-add' link={<a href='/feed'>
      <Msg m={messages.viewFeed} />
    </a>}>
      <T id='MiniFeed.toSeeRidesV2' defaultMessage='Follow users to see their rides and unlock more features.' />
    </IntroWidget>
  </Card>
)

const SubscriptionMiniFeedItem = ({ userName, accountLevel }) => {
  const premium = accountLevel === 2
  return <span>
    <T id='SubscriptionMiniFeedItem.text'
      defaultMessage='{user} upgraded to {level}'
      values={{
        user: <strong>{userName}</strong>,
        level: <strong className={premium ? styles.orange : undefined}>RWGPS <Msg m={premium ? accountLevels.premium : accountLevels.basic} /> </strong>
      }} />
    <AccountTypeBadge accountLevel={accountLevel} size={14} className={!premium && styles.darkgrey} />
  </span>
}
